module.exports = __webpack_public_path__ + "img/8a.1ed39f4d.svg";